import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const DATE_FORMAT = "YYYY-MM-DD";
const REPORTING_TIMEZONE = "America/New_York";

function calendarDate(value) {
  return dayjs.utc(dayjs(value).format(DATE_FORMAT));
}

export function reportingToday(now = dayjs()) {
  return dayjs.utc(dayjs(now).tz(REPORTING_TIMEZONE).format(DATE_FORMAT));
}

export function resolveDateRange(preset, today = reportingToday()) {
  const endDate = calendarDate(today);
  const thisWeekStart = endDate.subtract(endDate.day(), "day");

  switch (preset) {
    case "today":
      return { startDate: endDate, endDate };
    case "yesterday": {
      const yesterday = endDate.subtract(1, "day");
      return { startDate: yesterday, endDate: yesterday };
    }
    case "this_week":
      return { startDate: thisWeekStart, endDate };
    case "last_week":
      return {
        startDate: thisWeekStart.subtract(7, "day"),
        endDate: thisWeekStart.subtract(1, "day"),
      };
    case "mtd":
      return { startDate: endDate.startOf("month"), endDate };
    case "last_month": {
      const lastMonthEnd = endDate.startOf("month").subtract(1, "day");
      return {
        startDate: lastMonthEnd.startOf("month"),
        endDate: lastMonthEnd,
      };
    }
    case "ytd":
      return { startDate: endDate.startOf("year"), endDate };
    default:
      throw new Error(`Unknown date range preset: ${preset}`);
  }
}

// The previous period of the same length, moved back by whole weeks so every
// day compares with the same weekday (Monday with Monday, Shabbat with Shabbat).
export function previousPeriodComparison(startDate, endDate) {
  const start = calendarDate(startDate);
  const end = calendarDate(endDate);
  const days = end.diff(start, "day") + 1;
  const shift = Math.ceil(days / 7) * 7;

  return {
    comparison: "custom",
    comparison_start_date: start.subtract(shift, "day").format(DATE_FORMAT),
    comparison_end_date: end.subtract(shift, "day").format(DATE_FORMAT),
  };
}
